/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { TICKET_STATUSES } from '../constants';

export const updateTicketStatusRequestSchema = z.object({
  status: z.enum(TICKET_STATUSES),
});

export type IUpdateTicketStatusRequest = z.infer<typeof updateTicketStatusRequestSchema>;
